<template>
    <b-container>
        <div class="row">
            <div class="col-11 mx-auto">
                <h2 class="m-0 h1 text-uppercase">{{ $t('partido.completar_datos') }}</h2>
                <div class="subtitle h3 light">
                    {{ $t('partido.completa_info') }}.
                </div>
                <ValidationObserver tag="form" ref="observer2" @submit.prevent="submit()">
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="localDatosCompradores.nombre"
                                id="nombre"
                                rules="required" 
                                :disabled="desactivar"
                                :label="$t('formularios.nombre')"
                                :name="$t('formularios.nombre')"
                            />
                        </div>
                        <div class="col-12 col-lg-6" v-if="localDatosCompradores.tipo_dni !== 'NIF'">
                            <FormInput
                                v-model="localDatosCompradores.apellidos"
                                id="apellidos"
                                rules="required" 
                                :disabled="desactivar"
                                :label="$t('formularios.apellidos')"
                                :name="$t('formularios.apellidos')"
                            />
                        </div>              
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="localDatosCompradores.edad"
                                id="edad"
                                rules="required" 
                                :disabled="desactivar"
                                :label="$t('formularios.edad')"
                                :name="$t('formularios.edad')"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="form-group">
                                <label>{{ $t('formularios.telefono') }}</label>
                                <PhoneInput 
                                    :phone="localDatosCompradores.telefono"
                                    :desactivar="desactivar"
                                    :required="false"
                                    @setNumber="setPhoneNumber"
                                    @validNumber="(valid) => isValidNumber = valid"
                                />
                            </div>
                        </div>  
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="localDatosCompradores.cp"
                                id="cp"
                                rules="required" 
                                :disabled="desactivar"
                                :label="$t('formularios.cp')"
                                :name="$t('formularios.cp')"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <DocumentoTipo
                                :value="localDatosCompradores.tipo_dni"
                                @input="val => { localDatosCompradores.tipo_dni = val; }"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <DocumentoValor
                                :type="localDatosCompradores.tipo_dni"
                                :value="localDatosCompradores.dni"
                                @input="val => { localDatosCompradores.dni = val; }"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="localDatosCompradores.email"
                                id="email"
                                vid="confirmation"
                                rules="required|email"
                                :disabled="desactivar"
                                :label="$t('formularios.email')"
                                :name="$t('formularios.email')"
                            />
                        </div>
                        <div class="col-12 col-lg-6">
                            <FormInput
                                v-model="localDatosCompradores.email_confirmation"
                                id="email_confirmation"
                                :rules="'required|confirmed_ci:@confirmation'"
                                :disabled="desactivar"
                                :label="$t('formularios.confirmar_email')"
                                :name="$t('formularios.confirmar_email')"
                            />
                        </div>
    
                        <template v-if="errors">
                            <div class="col-11 alert alert-danger m-auto" style="margin-bottom: 15px !important;" v-for="(error, index) in errors" :key="index" id="errors">
                                <ul class="p-1 m-0">
                                    <li><b>{{ 'El campo ' + error.message }}</b></li>
                                </ul>
                            </div>
                        </template>
                    </div>
    
                    <div>
                        <p class="h3 text-bold my-3">
                            {{ $t('eventos.entradas_nominativas_titulo') }}
                        </p>
                        <br/>
                        <p class="text-bold">
                            {{ $t('eventos.entradas_nominativas_datos') }}
                        </p>
                        <br/>
                        <p class="text-bold">
                            {{ $t('eventos.entradas_nominativas_documento') }}
                        </p>
                    </div>

                    <div class="h5 mt-lg-5">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="rellenar_datos_entradas" v-model="rellenar_datos_entradas" />
                            <label for="rellenar_datos_entradas" class="custom-control-label mb-1">
                                Rellenar los datos de la primera entrada con los datos del comprador
                            </label>
                        </div>
                    </div>
    
                    <template v-if="Array.isArray(items_carrito) && items_carrito.length > 0">
                        <div v-for="(entrada, index) in array_entradas" :key="'entrada-' + entrada.id + '-' + reload">
                            <EntradaFormComponent
                                :entrada.sync="array_entradas[index]"
                                :index="index"
                                :desactivar="desactivar"
                            />
                        </div>
                    </template>
                    <div class="d-flex flex-md-row justify-content-center justify-content-md-start mt-4 mb-5">
                        <button 
                            id="compra-responsive" 
                            :class="['button', 'large-button', { 'effect-button': !desactivar }]" 
                            type="submit" 
                            :disabled="desactivar || loading"
                        >
                            <span>{{ $t('partido.continuar') }}</span>
                        </button>
    
                        <span
                            v-if="!desactivar"
                            id="atras" 
                            :class="['button', 'large-button', 'ml-lg-3', 'compra-responsive', { 'effect-button': !desactivar }]"
                            @click="cambiarAsiento()"
                        >
                            <span>{{ $t('formularios.atras') }}</span>
                        </span>
                    </div>
                </ValidationObserver>
            </div>
        </div>
    </b-container>
</template>

<script>
    import { isMobileOnly, isTablet, isBrowser } from 'mobile-device-detect';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";
    import EntradaFormComponent from './EntradaFormComponent';

    export default {
        props: {
            items_carrito: {
                type: Array,
                required: true,
                default: () => []
            },
            sga_event_id: {
                type: String,
                required: true
            },
            datos_comprador: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                isValidNumber: false,
                isValidNumberEntrada: false,
                localDatosCompradores: { ...this.datos_comprador },
                loading: false,
                errors: null,
                solicitar_datos: true,       
                desactivar: false,
                array_entradas: [],
                rellenar_datos_entradas: false,
                reload: 1
            }
        },
        mounted() {
            this.$refs.observer2.reset();
        },
        created() {
            this.añadirDispositivo();

            if (Array.isArray(this.items_carrito) && this.items_carrito.length > 0) {
                this.array_entradas = this.items_carrito.map(entrada => ({
                    id: entrada.id,
                    name: `${entrada.zona?.name || 'Entrada'} - Fila ${entrada.row} - Asiento ${entrada.seat}`,
                    nombre: entrada.nombre ?? '',
                    apellidos: entrada.apellidos ?? '',
                    dni: entrada.dni ?? '',
                    documento_tipo: entrada.documento_tipo ?? ''
                }));
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            sga_eventos_cart_id() {
                return parseInt(localStorage.getItem('sga_eventos_cart_id'));
            }
        },
        methods: {
            guardarDatos() {
                this.loading = true;
                this.errors = null;

                const cart_id = this.sga_eventos_cart_id;
                
                if (!cart_id) {
                    this.$toast.error('No se encontró un carrito activo');
                    this.loading = false;
                    return;
                }

                const isNIF = this.localDatosCompradores.tipo_dni === 'NIF';

                const params = {
                    cart_id: cart_id,
                    tipo: 'eventos',
                    event_session_id: this.sga_event_id,
                    comprador: {
                        name: this.localDatosCompradores.nombre,
                        ...(!isNIF && { lastName: this.localDatosCompradores.apellidos }),
                        email: this.localDatosCompradores.email,
                        phone: this.localDatosCompradores.telefono,
                        identification: {
                            type: this.localDatosCompradores.tipo_dni,
                            value: this.localDatosCompradores.dni,
                            issuerCode: "ES"
                        }
                    },
                    items: this.array_entradas.map((entrada, index) => ({
                        id: entrada.id || index,
                        name: entrada.nombre,
                        ...(!isNIF && { lastName: entrada.apellidos }),
                        identification: {
                            type: entrada.documento_tipo,
                            value: entrada.dni,
                            issuerCode: "ES"
                        }
                    }))
                };

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.guardar-datos'), params).then(res => {
                    this.$emit('fillDatosCompradores', this.localDatosCompradores, this.array_entradas);
                    this.solicitarDatosCobro();
                }).catch(error => {
                    if (error.response?.data?.message === 'Error de validación') {
                        this.errors = error.response.data.errors;
                    } else {
                        this.$toast.error(error.response?.data?.message || 'Error al guardar los datos');
                    }
                });
            },
            async submit() {
                const isValid = await this.$refs.observer2.validate();
                if(isValid && this.isValidNumber) {
                    this.guardarDatos();
                } else {
                    this.$nextTick(function() {
                        this.$scrollTo('.is-invalid', 100)
                    });
                }
            },
            solicitarDatosCobro() {
                const params = {
                    filters: {},
                    cart_id: this.sga_eventos_cart_id
                }

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.solicitar-cobro'), params).then(res => {
                    this.$emit('setDatosCobro', res.data.jet_id, res.data.formulario, res.data.session_id, res.data.cart_id);
                }).finally(() => {
                    this.loading = false;
                });
            },
            cambiarAsiento() {
                this.$emit('volver');
            },
            añadirDispositivo() {
                if (isMobileOnly) this.localDatosCompradores.dispositivo = 0;
                if (isTablet) this.localDatosCompradores.dispositivo = 1;
                if (isBrowser) this.localDatosCompradores.dispositivo = 2;
            },
            setPhoneNumber(number) {
                if (number && number !== undefined && !isNaN(number)) {
                    this.localDatosCompradores.telefono = number;
                }
            },
            sincronizarPrimeraEntrada() {
                if (this.array_entradas[0]) {
                    this.array_entradas[0].nombre = this.localDatosCompradores.nombre;
                    this.array_entradas[0].apellidos = this.localDatosCompradores.apellidos;
                    this.array_entradas[0].dni = this.localDatosCompradores.dni;
                    this.array_entradas[0].documento_tipo = this.localDatosCompradores.tipo_dni;

                    this.reload++;
                }
            }
        },
        watch: {
            rellenar_datos_entradas(val) {
                if (val) {
                    this.sincronizarPrimeraEntrada();
                }
            },
            'localDatosCompradores.nombre'(val) {
                if (this.rellenar_datos_entradas && this.array_entradas[0]) {
                    this.array_entradas[0].nombre = val;
                    this.reload++;
                }
            },
            'localDatosCompradores.apellidos'(val) {
                if (this.rellenar_datos_entradas && this.array_entradas[0]) {
                    this.array_entradas[0].apellidos = val;
                    this.reload++;
                }
            },
            'localDatosCompradores.email'(val) {
                if (this.rellenar_datos_entradas && this.array_entradas[0]) {
                    this.array_entradas[0].email = val;
                    this.reload++;
                }
            },
            'localDatosCompradores.dni'(val) {
                if (this.rellenar_datos_entradas && this.array_entradas[0]) {
                    this.array_entradas[0].dni = val;
                    this.reload++;
                }
            },
            'localDatosCompradores.tipo_dni'(val) {
                if (this.rellenar_datos_entradas && this.array_entradas[0]) {
                    this.array_entradas[0].documento_tipo = val;
                    this.reload++;
                }
            }
        },
        components: { PhoneInput, DocumentoTipo, DocumentoValor, EntradaFormComponent }
    }
</script>

<style scoped>
@media (max-width: 700px) {
   .button.large-button {
        min-width: 40vw !important;
        margin-right: 4%;
    }

    #compra-responsive {
        min-width: 45vw;
        margin-left: 2px;
        font-size: 14px;
    }
    .compra-responsive {
        min-width: 40vw !important;
        margin-left: 5px !important;
        font-size: 14px !important;
    }
}
</style>